<script>
  import About from './About.svelte'
  import Contact from './Contact.svelte'
  import Customers from './Customers.svelte'
  import Facilities from './Facilities.svelte'
  import Services from './Services.svelte'
  export let path
</script>

{#if path == '/about'}
  <About />
{:else if path == '/contact'}
  <Contact />
{:else if path == '/customers'}
  <Customers />
{:else if path == '/facilities'}
  <Facilities />
{:else if path == '/services'}
  <Services />
{:else}
  <div class="content">
    <h1>Not Found</h1>
    <p>The page you requested was not found.</p>
  </div>
{/if}

<style>
  .content{
    margin: 0 6%;
  }
</style>
